import { render, staticRenderFns } from "./goodsconfirm.vue?vue&type=template&id=b88c7fa4&scoped=true"
import script from "./goodsconfirm.vue?vue&type=script&lang=js"
export * from "./goodsconfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b88c7fa4",
  null
  
)

export default component.exports